module.exports = __webpack_public_path__ + "img/edge.a46c2332.png";